module.exports = __webpack_public_path__ + "img/logo-light.4cb4554d.svg";